import scraperApi from "api";
import { ActiveSubscriptionDataRouteType } from "routes/data-routes/billing-data/active-subscription/route.meta";


export const cancelSubscriptionAction: NonNullable<ActiveSubscriptionDataRouteType["route"]["action"]> = async ({ request }) => {
  try {
    const activeSubscription = await scraperApi.subscription.cancel({ signal: request.signal });
    // redirecting to the cancellation survey will happen in the modal component, after a successful response from here
    return { activeSubscription };
  } catch (error) {
    const err = error as any;
    return {
      error: {
        message: err.message || "Unexpected error when cancelling the subscription",
        meta: {
          shouldNotRetry: err.error_code === "user_outstanding_invoices"
        }
      }
    };
  }

};
